

import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDragExit } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { CourseManagementService } from "../course-management.service"
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
@Component({
  selector: 'app-add-course-detail',
  templateUrl: './add-course-detail.component.html',
  styleUrls: ['./add-course-detail.component.scss']
})
export class AddCourseDetailComponent implements OnInit {

  courseDetailForm: FormGroup;
  formSubmitted: boolean = false;
  showLessonError: boolean = true;
  showWeekError: boolean = true;
  showAdditionalError: boolean = true;
  imageUpload: boolean = false;


  ImageUpload: boolean = false;
  showImageError: boolean = true;
  selectedFile: any;
  uploadCourseImage: any;
  courseId: string;

  thumpImage: string;
  uploadthumpImage: Boolean = false;
  showthumpImageError: Boolean = true;
  ImagethumpUpload: boolean = false;


  courseDetailReq = {
    courseId: null,
    title: null,
    weekLabel: null,
    week: null,
    imageUrl: null,
    videoUrl: "NA",
    thumbnailUrl: null,
    sortOrder: null,
    description: null,
    lessonTopics: [],
    weeksActionSteps: [],
    additionalResources: []
  }
  lessonTopicList = [];
  weeksActionStepList = [];
  additonalResourseList = [];
  typelist = [
    { value: 'normal', viewValue: 'Normal' },
    { value: 'webview', viewValue: 'Web View' },
    { value: 'webdoc', viewValue: 'Doc View' },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private courseManagementService: CourseManagementService,

  ) { }

  ngOnInit() {
    this.courseId = this.route.snapshot.params["course_Id"];
    this.initialiseForms();
    this.courseDetailForm.reset();
  }

  AddLesson() {
    this.lessonTopicList.push(this.courseDetailForm.value.lessonDescription.trim())
    if (this.lessonTopicList.length > 0) {
      this.showLessonError = false;
      this.courseDetailForm.controls['lessonDescription'].setValue(" ");
    }
  }
  addWeekStep() {
    this.weeksActionStepList.push(this.courseDetailForm.value.weekDescription.trim())
    if (this.weeksActionStepList.length > 0) {
      this.showWeekError = false;
      this.courseDetailForm.controls['weekDescription'].setValue(" ");
    }
  }

  addAdditional() {
    let url = this.courseDetailForm.value.additionalWebViewUrl.trim();
    if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    this.additonalResourseList.push({ description: this.courseDetailForm.value.additionalDescrption.trim(), title: this.courseDetailForm.value.additionaltitle.trim(), type: this.courseDetailForm.value.additionalType, webViewUrl: url })
    if (this.additonalResourseList.length > 0) {
      this.showAdditionalError = false;
      this.courseDetailForm.controls['additionalDescrption'].setValue(" ");
      this.courseDetailForm.controls['additionalType'].setValue(" ");
      this.courseDetailForm.controls['additionalWebViewUrl'].setValue(" ");
      this.courseDetailForm.controls['additionaltitle'].setValue(" ");
    }

  }


  onFileChanged(event) {
    const file = event.target.files[0];
    if (!file) return;

    console.log("File selected for Lesson Image:", file.name, file.type);

    const fileType = file.type.toLowerCase();
    const fileName = file.name.toLowerCase();
    const isImage = fileType.startsWith('image/');
    const isVideo = fileType.includes('video') || fileName.endsWith('.mp4') || fileName.endsWith('.mov') || fileName.endsWith('.avi');
    const isPdf = fileType.includes('pdf') || fileName.endsWith('.pdf');

    if (!isImage || isVideo || isPdf) {
      console.log("Validation FAILED for Lesson Image");
      Swal.fire({
        type: "error",
        title: "Invalid File Type",
        text: "Please select an image file (PNG, JPG, or WEBP). Videos and PDFs are not allowed here."
      });
      event.target.value = ''; // Reset input
      return;
    }

    console.log("Validation PASSED for Lesson Image. Proceeding to upload...");
    this.spinner.show();
    this.courseManagementService.uploadImage(file).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseDetailReq.imageUrl = data.data.fileUrl;
        this.uploadCourseImage = data.data.fileUrl;
        this.imageUpload = true;
        this.showImageError = false;
        this.ImageUpload = true;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        event.target.value = '';
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    }, error => {
      this.spinner.hide();
      event.target.value = '';
      Swal.fire("Error", "Upload failed", "error");
    });
  }

  onFileChangedthump(event) {
    const file = event.target.files[0];
    if (!file) return;

    console.log("File selected for Thumbnail Image:", file.name, file.type);

    const fileType = file.type.toLowerCase();
    const fileName = file.name.toLowerCase();
    const isImage = fileType.startsWith('image/');
    const isVideo = fileType.includes('video') || fileName.endsWith('.mp4') || fileName.endsWith('.mov') || fileName.endsWith('.avi');
    const isPdf = fileType.includes('pdf') || fileName.endsWith('.pdf');

    if (!isImage || isVideo || isPdf) {
      console.log("Validation FAILED for Thumbnail Image");
      Swal.fire({
        type: "error",
        title: "Invalid File Type",
        text: "Please select an image file (PNG, JPG, or WEBP). Videos and PDFs are not allowed here."
      });
      event.target.value = ''; // Reset input
      return;
    }

    console.log("Validation PASSED for Thumbnail Image. Proceeding to upload...");
    this.spinner.show();
    this.courseManagementService.uploadImage(file).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseDetailReq.thumbnailUrl = data.data.fileUrl;
        this.thumpImage = data.data.fileUrl;
        this.showthumpImageError = false;
        this.ImagethumpUpload = true;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        event.target.value = '';
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    }, error => {
      this.spinner.hide();
      event.target.value = '';
      Swal.fire("Error", "Upload failed", "error");
    });
  }

  onVideoFileChanged(event) {
    const file = event.target.files[0];
    const allowedTypes = ['video/mp4', 'video/webm', 'video/ogg'];
    if (file && !allowedTypes.includes(file.type)) {
      Swal.fire("Error", "Please select a valid video file (MP4, WEBM, or OGG)", "error");
      return;
    }
    if (file) {
      this.spinner.show();
      this.courseManagementService.uploadVideo(file).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Video uploaded successfully!", "success");
          this.courseDetailForm.controls['videoUrl'].setValue(data.data.fileUrl);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, error => {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Something went wrong while uploading video"
        });
      });
    }
  }

  initialiseForms() {
    this.courseDetailForm = this.fb.group({
      title: ["", [Validators.required]],
      weekLabel: ["", [Validators.required]],
      week: ["", [Validators.required]],
      imageUrl: [, [Validators]],
      videoUrl: [, [Validators]],
      sortOrder: [, [Validators.required]],
      thumbnailUrl: [, [Validators]],
      description: [, [Validators.required]],
      lessonDescription: [, [Validators]],
      weekDescription: [, [Validators]],
      additionalDescrption: [, [Validators]],
      additionalType: [, [Validators]],
      additionalWebViewUrl: [, [Validators]],
      additionaltitle: [, [Validators]],
    });
  }




  AddCourseDetail() {
    let lesson = [];
    let weekAction = [];
    let additional = [];
    this.formSubmitted = true;


    if (this.courseDetailForm.valid && this.imageUpload == true && this.ImagethumpUpload == true) {

      this.lessonTopicList.forEach((element, index) => {
        lesson.push({ description: element, sortOrder: index });
        this.courseDetailReq.lessonTopics = lesson;
      });

      this.weeksActionStepList.forEach((element, index) => {
        weekAction.push({ description: element, sortOrder: index });
        this.courseDetailReq.weeksActionSteps = weekAction;
      });
      this.additonalResourseList.forEach((element, index) => {
        additional.push({ description: element.description, sortOrder: index, title: element.title, webViewUrl: element.webViewUrl, type: element.type });
        this.courseDetailReq.additionalResources = additional;
      });

      this.courseDetailReq.courseId = this.courseId;
      this.courseDetailReq.title = this.courseDetailForm.value.title;
      this.courseDetailReq.week = this.courseDetailForm.value.week;
      this.courseDetailReq.weekLabel = this.courseDetailForm.value.weekLabel;
      let vUrl = this.courseDetailForm.value.videoUrl ? this.courseDetailForm.value.videoUrl.trim() : null;
      if (vUrl && !vUrl.startsWith('http://') && !vUrl.startsWith('https://')) {
        vUrl = 'https://' + vUrl;
      }
      this.courseDetailReq.videoUrl = vUrl;
      this.courseDetailReq.description = this.courseDetailForm.value.description;
      this.courseDetailReq.sortOrder = this.courseDetailForm.value.sortOrder;

      if (!this.courseDetailReq.videoUrl || this.courseDetailReq.videoUrl == " ") {
        delete this.courseDetailReq.videoUrl;
      }

      if (this.courseDetailReq.imageUrl == null || this.courseDetailReq.imageUrl == " ") {
        delete this.courseDetailReq.imageUrl;
      }

      this.courseManagementService.saveCourseDetail(this.courseDetailReq).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Lesson Added successfully!", "success");
          this.router.navigate(['main/course-management/view-lesson/', this.courseId]);

        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });

    }
    else if (this.imageUpload == false) {
      Swal.fire({
        type: "error",
        title: "Error",
        text: "Please Upload Image"
      });
    }


  }



  dropAdditional(event: CdkDragDrop<string[]>) {
    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {

      let tempValue = this.additonalResourseList[event.currentIndex];
      this.courseDetailForm.controls['additionalDescrption'].setValue(tempValue.description);
      this.courseDetailForm.controls['additionalType'].setValue(tempValue.type);
      this.courseDetailForm.controls['additionalWebViewUrl'].setValue(tempValue.webViewUrl);
      this.courseDetailForm.controls['additionaltitle'].setValue(tempValue.title);
      this.additonalResourseList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.additonalResourseList, event.previousIndex, event.currentIndex);

  }
  droplesson(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      let tempValue = this.lessonTopicList[event.currentIndex];
      this.courseDetailForm.controls['lessonDescription'].setValue(tempValue);
      this.lessonTopicList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.lessonTopicList, event.previousIndex, event.currentIndex);

  }
  dropweekstep(event: CdkDragDrop<string[]>) {
    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      let tempValue = this.weeksActionStepList[event.currentIndex];
      this.courseDetailForm.controls['weekDescription'].setValue(tempValue);
      this.weeksActionStepList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.weeksActionStepList, event.previousIndex, event.currentIndex);
  }



  resetLession() {
    this.lessonTopicList = [];
    this.courseDetailForm.controls['lessonDescription'].setValue(" ");
    this.showLessonError = true;
  }
  resetWeek() {
    this.weeksActionStepList = [];
    this.courseDetailForm.controls['weekDescription'].setValue(" ");
    this.showWeekError = true;
  }
  resetAdditional() {
    this.weeksActionStepList = [];
    this.courseDetailForm.controls['weekDescription'].setValue(" ");
    this.showWeekError = true;
  }
  resetLessionSingle(index) {
    this.lessonTopicList.splice(index, 1);
  }
  resetWeekSingle(index) {
    this.weeksActionStepList.splice(index, 1);
  }
  resetAdditionalSingle(index) {
    this.additonalResourseList.splice(index, 1);
  }
  cancel() {
    this.router.navigate(['main/course-management/view-lesson/', this.courseId]);
  }
}

